/**
 * Created by vonsh on 2018/8/28
 */
import M from '@/mobile/m'
import Home from '@/mobile/Home'
import Technology from '@/mobile/Technology';
import Production from '@/mobile/Production';
import Solution from '@/mobile/Solution';
import Case from '@/mobile/Case';
import AboutUs from '@/mobile/AboutUs'
import NewsLyt from '@/mobile/NewsLyt'
import NewsList from '@/mobile/NewsList'
import NewsDetails from '@/mobile/NewsDetails.vue'
import JoinUs from '@/mobile/JoinUs'
import JoinDetail from '@/mobile/JoinDetail'
import CompanyProfile from '@/mobile/CompanyProfile'

export default [
  {
    path: '/mobile',
    component: M,
    children: [{
      path: '/',
      name: 'mHome',
      component: Home
    }, {
      path: '/mobile/tech',
      name: 'mTech',
      title: '核心技术',
      component: Technology
    }, {
      path: '/mobile/produc/:type',
      name: 'mProduction',
      title: '产品中心',
      component: Production
    }, {
      path: '/mobile/solution',
      name: 'mSolution',
      title: '解决方案',
      component: Solution
    }, {
      path: '/mobile/case/:type',
      name: 'mCase',
      title: '经典案例',
      component: Case
    }, {
      path: '/mobile/aboutUs',
      name: 'mAboutUs',
      title: '关于我们',
      component: AboutUs
    }, {
      path: '/mobile/news',
      name: 'mNewsHome',
      title: '资讯中心',
      component: NewsLyt,
      children: [{
        path: '/mobile/news/',
        name: 'mNews',
        title: '资讯中心',
        component: NewsList
      }, {
        path: '/mobile/news/info/:id',
        name: 'mNewsDetail',
        title: '资讯中心',
        component: NewsDetails
      }]
    }, {
      path: '/mobile/joinUs',
      name: 'mJoinUs',
      title: '加入我们',
      component: JoinUs
    }, {
      path: '/mobile/joinUs/:id',
      name: 'mJoinDetail',
      title: '职位详情',
      component: JoinDetail
    }, {
      path: '/mobile/companyProfile',
      name: 'mCompanyProfile',
      title: '公司简介',
      component: CompanyProfile
    }]
  }
]



// WEBPACK FOOTER //
// ./src/router/mobile.js